<template>
  <div class="aui-content">
    <!-- new -->

    <header class="aui-bar aui-bar-nav">
      <router-link class="aui-pull-left aui-btn" to="/supply">
        <span class="aui-iconfont aui-icon-left"></span>
      </router-link>
      <div class="aui-title">详细</div>
    </header>
    <div class="aui-content">
      <ul class="aui-list aui-media-list maui-detail-list">
        <li class="aui-list-item">
          <!-- 轮播图 -->
          <div>
            <div class="scrhome">
              <van-swipe
                class="my-swipe"
                @change="onChange"
                :loop="false"
                :initial-swipe="initialswip"
              >
                <van-swipe-item
                  v-for="(item, i) in pictureUrls"
                  :key="i"
                  @click="ab"
                >
                  <img :src="item.url" alt />
                </van-swipe-item>

                <div class="custom-indicator definearr" slot="indicator">
                  {{ current + 1 }}/{{ picnumber }}
                </div>
              </van-swipe>

              <van-image-preview
                v-model="show"
                :images="imagesa"
                @change="onChangae"
                :startPosition="startp"
              >
                <template v-slot: index
                  >{{ index + 1 }}/{{ picnumber }}</template
                >
              </van-image-preview>
            </div>
          </div>

          <div class="aui-media-list-item-inner battery-supfoet">
            <div class="aui-list-item-inner">
              <div class="aui-list-item-text">
                <div class="aui-list-item-title" style="font-size: 1.2rem">
                  {{ title }}
                </div>
                <div v-if="number == 0">
                  <img src="../assets/sq1.png" style="width: 60px" />
                </div>
                <div v-else>
                  <img src="../assets/rm1.png" style="width: 60px" />
                </div>
              </div>
              <div class="maui-list-item" style="margin-top: 10px">
                <div
                  class="aui-label"
                  style="font-size: 0.7rem; background-color: #fff"
                  v-if="sdratio == 1"
                >
                  库存：{{ number }}{{ unit }}
                </div>
                <div
                  class="aui-label"
                  style="font-size: 0.7rem; background-color: #fff"
                  v-else
                >
                  库存：{{ number }}{{ unit }} 已售：{{ spWeight - number
                  }}{{ unit }}
                </div>
                <div
                  class="aui-label maui-label-green"
                  style="font-size: 0.7rem"
                >
                  {{ goodsClassName }}
                </div>
              </div>
              <div
                class="maui-list-item"
                style="margin-top: 10px"
                v-if="isyy == 1"
              >
                <div
                  class="aui-label"
                  style="font-size: 0.7rem; background-color: #fff"
                >
                  可预约人数：{{ yyNum }} 已报名人数：{{ bmNum }}
                </div>
              </div>

              <div v-if="isyy == 1">
                <div style="color: red">
                  注意：货款金额非支付金额，该订单线上仅支付服务费
                  <span
                    @click="showMsg()"
                    style="
                      cursor: pointer;
                      text-decoration: underline;
                      color: #008080;
                    "
                    >（点击查看服务费标准）</span
                  >
                  ，货款由买卖双方线下洽谈成交，本平台将为您提供货源信息及相关服务，请您及时联系客服
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="aui-content maui-info-textbox">
      <h2>基本信息</h2>
      <ul class="aui-list aui-form-list">
        <li v-if="rzsp == 1" style="padding-left: 15px">
          检测报告：
          <div v-for="(item, index) in pdfpic" :key="index">
            <img :src="item" @click="getImg(index)" class="my-img" />
          </div>
        </li>
        <li
          style="padding-left: 15px"
          v-if="czPath != '' && czPath != undefined"
        >
          称重：
          <div v-if="czType == 1">
            <img :src="czPath" @click="getImg2(czPath)" />
          </div>
          <div v-if="czType == 2">
            <video
              id="video1"
              :src="czPath"
              preload="auto"
              x-webkit-airplay="allow"
              x5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              x5-video-orientation="portraint"
              width="100%"
              height="260px"
              webkit-playsinline="true"
              playsinline="true"
              controls="true"
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </li>
        <li
          style="padding-left: 15px"
          v-if="qyPath != '' && qyPath != undefined"
        >
          取样：
          <div v-if="qyType == 1">
            <img :src="qyPath" @click="getImg2(qyPath)" />
          </div>
          <div v-if="qyType == 2">
            <video
              id="video2"
              :src="qyPath"
              preload="auto"
              x-webkit-airplay="allow"
              x5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              x5-video-orientation="portraint"
              width="100%"
              height="260px"
              webkit-playsinline="true"
              playsinline="true"
              controls="true"
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </li>
        <li
          style="padding-left: 15px"
          v-if="zyPath != '' && zyPath != undefined"
        >
          制样：
          <div v-if="zyType == 1">
            <img :src="zyPath" @click="getImg2(zyPath)" />
          </div>
          <div v-if="zyType == 2">
            <video
              id="video3"
              :src="zyPath"
              preload="auto"
              x-webkit-airplay="allow"
              x5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              x5-video-orientation="portraint"
              width="100%"
              height="260px"
              webkit-playsinline="true"
              playsinline="true"
              controls="true"
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </li>
      </ul>
      <ul
        class="aui-list aui-form-list"
        v-for="(items, i) in specificationsDetail"
        :key="i"
      >
        <li class="aui-list-item">
          <div class="aui-list-item-inner">
            <div class="aui-list-item-label">{{ items.name }}</div>
            <div class="aui-list-item-input">
              <input
                type="text"
                v-for="(item, index) in items.infoList"
                :key="index"
                v-model="item.name"
                readonly
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- <div>
      <div class="aui-content maui-info-textbox">
        <h2>公司信息</h2>
        <div>
          <div class="battery-suppplyform-companyinfor">
            <div>
              <p>公司名称</p>
              <span>{{ companyName }}</span>
            </div>
            <div>
              <p>公司地址</p>
              <span>{{ companyAddress }}</span>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="aui-content maui-info-textbox">
      <h2>信息描述</h2>
      <div class="maui-textbox" v-html="content">
        {{ content }}
      </div>
    </div>
    <!-- <div class="aui-content maui-info-textbox">
      <div class="battery-s-code">
        <img src="/static/image/ptLogo.jpg" alt= />
      </div>
    </div> -->
    <div class="aui-content maui-info-textbox">
      <div class="maui-list-item" style="margin-top: 10px">
        <div class="mymarginleft">
          <van-stepper
            v-model="num"
            :min="onecode"
            :max="maxNum"
            :step="onecode"
            input-width="40px"
            button-size="40px"
            style="float: left; font-size: 0.8rem"
          />
        </div>

        <div
          class="aui-list-item-text"
          v-if="estimatedPrice != ''"
          style="float: right; margin-top: 0.5rem; margin-right: 1rem"
        >
          <span v-if="sdratio == 1">
            单价:￥<span style="color: #f00">{{ estimatedPrice }}</span
            >元</span
          >
          <span v-else>
            一次性整体价格:￥<span style="color: #f00">{{
              estimatedPrice
            }}</span
            >元</span
          >
        </div>
        <div v-else class="aui-list-item-text">
          <span>价格：面谈</span>
        </div>
      </div>
      <div class="maui-list-item" style="margin-top: 10px">
        <div
            class="aui-searchbar-cancel"
            @click="onabout"
            style="margin-right: 2%; margin-left: 2%"
            v-if="storeid !== '13c38c919a5d4f96bc344c2ef1149000'"
          >
            <van-button type="primary" round v-bind:disabled="dis" size="large"
              >立即购买</van-button
            >
          </div>
      </div>
    </div>

    <!-- new end -->
  </div>
</template>

<script>
import $ from "jquery";
import wechat from "../../static/js/wechat1.js";
import { Dialog, ImagePreview } from "vant";

export default {
  name: "ScrollerOne",
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data() {
    return {
      arr: [],
      showPage: 1,
      pageSize: 4,
      xqid: "",
      id: "",
      content: "",
      goodsClassName: "",
      pictureUrl: "",
      companyList: [],
      speciDetailList: "",
      pictureUrls: [],
      estimatedPrice: "",
      num: 1,
      onecode: 0,
      maxNum: 1,
      title: "",
      unit: "",
      number: "",
      current: 0,
      show: false,
      index: 0,
      picnumber: 0,
      imagesa: [],
      startp: 0,
      initialswip: 0,
      companyshow: false,
      code: "",
      nowurl: "",
      APPID: "wx1021cd04374194e7",
      openidn: "",
      codenew: "",
      option: {},
      companyAddress: "",
      companyName: "",
      specificationsDetail: [],
      dis: false,
      spuserid: "",
      files: "",
      rzsp: "",
      sdratio: "",
      sl: "",
      pdfpic: [],
      czType: "",
      czPath: "",
      qyType: "",
      qyPath: "",
      zyType: "",
      zyPath: "",
      spWeight: "",
      isyy: 0,
      yyNum: 0,
      bmNum: 0,
      dialogshow: false,
      storeid: "",
    };
  },
  mounted() {
    //this.getData();
    //this.url();
    this.authority();
    // this.rescompany();
  },
  methods: {
    //请求至服务端计数器
    supplycount() {
      this.$Axios
        .get("/changsha/f/hit/hitCount", {
          params: {
            id: this.id,
            sign: "spgoods",
          },
        })
        .then((res) => {
          console.log("请求计数器:" + res);
          if (res.status === 200) {
            return res.data;
          } else {
            return "error";
          }
        })
        .catch((error) => {
          console.log("this is error" + error);
        });
    },

    url() {
      this.nowual = window.location.href;
      console.log("当前路径：" + this.nowual);
    },
    authority() {
      let code = this.getQueryString("code");
      console.log("第一个函数：" + code);
      if (!code) {
        this.getWxCode();
      } else {
        this.getOpenId(code);
      }
    },
    getQueryString(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    getWxCode() {
      var nowUrl = window.location.href;
      nowUrl = encodeURIComponent(nowUrl);
      var url =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        this.APPID +
        "&redirect_uri=" +
        nowUrl +
        "&response_type=code&scope=snsapi_base&state=0#wechat_redirect";

      location.href = url;
    },
    getOpenId(code) {
      console.log("getOpenid函数：", code);
      this.codenew = code;
      let openId = sessionStorage.getItem("openId");
      let _this = this;
      if (!openId) {
        var param = {
          url: "/wx/mobile/service/getOpenId",
        };
        this.$axios
          .get("/wx/mobile/service/getOpenId", {
            params: {
              code: this.codenew,
            },
          })
          .then(function (json) {
            console.log(json);
            if (json) {
              if (json.data.openId) {
                sessionStorage.setItem("openId", json.data.openId);
                _this.rescompany(json.data.openId);
              }
            }
          });
      } else {
        this.rescompany(openId);
      }
    },
    showMsg() {
      var html =
        "订单金额低于20万(包含20万),服务费500元;\n" +
        "订单金额为20万-50万(包含50万),服务费800元;\n" +
        "订单金额高于50万,服务费为1200元;\n" +
        "当交易成功后,您在支付服务费后30天内,完成订单并上传支付凭证,将返还200元。\n" +
        "当交易未达成,请申请取消订单,将扣除50元工本费,返还剩余服务费。";
      Dialog.alert({
        message: html,
        messageAlign: "left",
        theme: "round-button",
      }).then(() => {
        // on close
      });
    },
    rescompany(name) {
      console.log("name" + name);
      this.xqid = this.$route.query.xqid;
      this.openidn = name;
      this.$axios
        .get(
          "/micro/permission_order-view/spgoods/read/supplyInfo?id=" +
            this.xqid +
            "&openId=" +
            this.openidn
        )
        .then((res) => {
          this.id = res.data.data.id;
          if (res.data.data.specificationsDetail != undefined) {
            this.specificationsDetail = eval(
              res.data.data.specificationsDetail
            );
          }

          this.companyName = res.data.data.companyName;
          this.companyAddress = res.data.data.companyAddress;
          console.log("============", this.specificationsDetail);
          let imgUrl = "";
          this.pictureUrls = res.data.data.pictureUrls;
          for (var i = 0; i < this.pictureUrls.length; i++) {
            if (i == 0) {
              imgUrl = this.pictureUrls[i].url;
            }
            this.imagesa.push(this.pictureUrls[i].url);
          }
          console.log(this.imagesa);
          this.picnumber = this.imagesa.length;
          this.content = res.data.data.goodsDetails;
          const regex = new RegExp('src="', "gi");
          let newContent = res.data.data.goodsDetails.replace(
            regex,
            function (match, capture) {
              match = match.replace(
                regex,
                'src="' + "https://www.lihuitong.net"
              );
              return match;
            }
          );
          this.content = newContent;
          console.log("content", this.content);
          this.unit = res.data.data.unit;
          this.estimatedPrice = res.data.data.storePrice;
          this.title = res.data.data.goodsName;
          this.number = res.data.data.goodsWeight;
          this.goodsClassName = res.data.data.inventoryTypeName;
          this.num = parseFloat(res.data.data.onecode);
          this.sl = res.data.data.onecode;
          this.rzsp = res.data.data.rzsp;
          this.files = res.data.data.files;
          this.spWeight = res.data.data.spWeight;
          this.isyy = res.data.data.isyy;
          this.yyNum = res.data.data.yyNum;
          this.bmNum = res.data.data.bmNum;
          if (
            res.data.data.pdfPicPath != null &&
            res.data.data.pdfPicPath != ""
          ) {
            let array = res.data.data.pdfPicPath.split("|");

            for (var i = 0; i < array.length; i++) {
              if (array[i] != "") {
                this.pdfpic.push("https://www.lihuitong.net" + array[i]);
              }
            }
            console.log("pdfpic:", this.pdfpic);
          }

          this.sdratio = res.data.data.sdratio;
          // console.log("-------------", this.num);
          if (res.data.data.onecode != "") {
            this.onecode = parseFloat(res.data.data.onecode);
          }

          this.maxNum = parseFloat(res.data.data.goodsWeight);
          if (this.maxNum < this.onecode) {
            this.onecode = this.maxNum;
            this.num = this.maxNum;
          }
          this.czType = res.data.data.czType;
          this.czPath = res.data.data.czPath;
          this.qyType = res.data.data.qyType;
          this.qyPath = res.data.data.qyPath;
          this.zyType = res.data.data.zyType;
          this.zyPath = res.data.data.zyPath;
          this.storeid = res.data.data.storeid;
          if(this.storeid == '13c38c919a5d4f96bc344c2ef1149000'){
            this.dis = false;
          }
          this.spuserid = res.data.data.createBy;
          this.option = {
            title: "供应：" + this.title,
            imgUrl: imgUrl,
            link: location.href.replace(/&code=[^&]*/, ""),
          };

          

          wechat.share(this.option);
          // this.supplycount();
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
    },
    onChange(index) {
      this.current = index;
    },
    onChangae(index) {
      this.index = index;
      this.initialswip = this.index;
      this.current = this.initialswip;
    },
    ab() {
      this.startp = this.current;
      this.show = true;
    },
    handleChange(value) {
      console.log(value);
    },
    onabout() {
      this.dis = true;
       if(this.storeid == '13c38c919a5d4f96bc344c2ef1149000'){
            this.dis = false;
             return false;
        }
      
      
      if (this.maxNum <= 0) {
        Dialog.alert({
          message: "暂无库存，无法下单",
          theme: "round-button",
        }).then(() => {
          // on close
        });
        this.dis = false;
        return false;
      }

      if (this.isyy == "1" && this.yyNum <= 0) {
        Dialog.alert({
          message: "预约购买名额已满，请稍后再试",
          theme: "round-button",
        }).then(() => {
          // on close
        });
        this.dis = false;
        return false;
      }

      if (parseFloat(this.num) > parseFloat(this.number)) {
        Dialog.alert({
          message: "输入数量大于库存，无法下单",
          theme: "round-button",
        }).then(() => {
          // on close
        });
        this.dis = false;
        return false;
      }
      //this.openidn = "oEN2Tjtw1eDgdUVumfCn0C_wE9uM";
      this.$axios
        .get("https://mobile.lihuitong.net/cswx/f/pmc/fp/pmcFp/wd2", {
          params: {
            openId: this.openidn,
          },
        })
        .then((res) => {
          var usertype = res.data.state;
          if (usertype > 0) {
            var userid = res.data.userid;
            if (userid == this.spuserid) {
              Dialog.alert({
                message: "您不能购买自己发布的商品",
                theme: "round-button",
              }).then(() => {
                // on close
              });

              return false;
            }
            if (usertype != 3) {
              Dialog.confirm({
                title: "提示",
                message: "是否确认下单",
                confirmButtonText: "确定", //改变确认按钮上显示的文字
                cancelButtonText: "取消", //改变取消按钮上显示的文字
              })
                .then(() => {
                  this.$axios
                    .get(
                      "https://mobile.lihuitong.net/cswx/f/orderall/order/shoppingAll/checkwzDd?openid=" +
                        this.openidn +
                        "&goodid=" +
                        this.id +
                        "&goodsprice=" +
                        this.estimatedPrice
                    )

                    .then((res) => {
                      if (res.status === 200) {
                        if (res.data.state == "1") {
                          this.$axios
                            .get(
                              "https://mobile.lihuitong.net/cswx/f/orderall/order/shoppingAll/savewzDd?openid=" +
                                this.openidn +
                                "&goodid=" +
                                this.id +
                                "&goodnumber=" +
                                this.num
                            )
                            .then((res) => {
                              if (res.status === 200) {
                                Dialog.alert({
                                  message: "下单成功！",
                                  theme: "round-button",
                                }).then(() => {
                                  this.dis = true;
                                  var url =
                                    "https://mobile.lihuitong.net/cswx/f/orderall/order/shoppingAll/info";
                                  location.href = url;
                                });
                              } else {
                                return "error";
                              }
                            });
                        } else if (res.data.state == "0") {
                          Dialog.alert({
                            message: "价格修改期，无法下单",
                            theme: "round-button",
                          }).then(() => {
                            // on close
                          });
                          this.dis = false;
                          return false;
                        } else if (res.data.state == "2") {
                          Dialog.alert({
                            message: "订单价格为空，无法下单",
                            theme: "round-button",
                          }).then(() => {
                            // on close
                          });
                          this.dis = false;
                          return false;
                        } else if (res.data.state == "3") {
                          Dialog.alert({
                            message: "无商品信息，不能下单",
                            theme: "round-button",
                          }).then(() => {
                            // on close
                          });
                          this.dis = false;
                          return false;
                        } else if (res.data.state == "4") {
                          Dialog.alert({
                            message: "当前价格不正确，不能下单",
                            theme: "round-button",
                          }).then(() => {
                            // on close
                          });
                          this.dis = false;
                          return false;
                        } else if (res.data.state == "5") {
                          Dialog.alert({
                            message: "预约购买名额已满，请稍后再试",
                            theme: "round-button",
                          }).then(() => {
                            // on close
                          });
                          this.dis = false;
                          return false;
                        } else if (res.data.state == "6") {
                          Dialog.alert({
                            message: "您已预约该商品购买名额，请勿重复下单",
                            theme: "round-button",
                          }).then(() => {
                            // on close
                          });
                          this.dis = false;
                          return false;
                        }
                      } else {
                        return "error";
                      }
                    });
                })
                .catch(() => {
                  this.dis = false;
                  console.log("点击了取消按钮噢");
                });
            } else {
              Dialog.alert({
                message: "您不是企业用户，不能下单",
                theme: "round-button",
              }).then(() => {
                this.dis = false;
              });
              return false;
            }
          } else {
            Dialog.alert({
              message: "请登录",
              theme: "round-button",
            }).then(() => {
              var url = "https://mobile.lihuitong.net/cswx/mobile/binding/info";
              location.href = url;
            });
            return false;
          }
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
    },
    getImg(index) {
      ImagePreview({
        images: this.pdfpic, // 预览图片的那个数组
        closeable: true,
      });
    },
    getImg2(path) {
      ImagePreview({
        images: [path], // 预览图片的那个数组
        closeable: true,
      });
    },
  },
};
</script>

<style scoped>
.battery-s-code {
  text-align: center;
}
.battery-s-code > img {
  margin: 0 auto;
  width: 90%;
}
.battery-suppplyform-companyinfor > div span {
  display: block;
  margin-left: 100px;
}
.battery-suppplyform-companyinfor > div p {
  position: absolute;
  left: 20px;
  top: 10px;
}
.battery-suppplyform-companyinfor > div {
  border-bottom: solid 1px #f0f0f0;
  font-size: 0.7rem;
  padding: 13px 20px;
  color: #858484;
  position: relative;
}
.battery-suppplyform-companyinfor span {
  color: #424242;
}
.battery-supfoet {
  margin-top: 10px;
}
.scrhome {
  position: relative;
  background: #d8d7d7;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;

  text-align: center;
}
.scrhome img {
  height: 100% !important;
  margin: 0 auto;
}
.van-image-preview__overlay {
  background-color: rgba(0, 0, 0, 1) !important;
}
.definearr {
  position: absolute;
  right: 0px;
  bottom: 14px;
  padding: 3px 20px 3px 20px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-weight: 400 !important;
  border-radius: 15px 0px 0px 15px;
}

.aui-bar-nav {
  background-color: #f2f2f2;
  color: #000;
}
.aui-bar-nav .aui-btn .aui-iconfont {
  color: #464646;
}
.aui-label-outlined.aui-label-danger,
.aui-label-outlined.aui-label-danger::after {
  border: solid 1px #c9eee1;
  color: #3bb18a;
}

.aui-list {
  background: none;
}
.aui-list .aui-list-item-title {
  font-size: 0.75rem;
}
.aui-label.maui-label-green {
  border: solid 2px #c9eee1;
  color: #3bb18a;
  background: none;
  font-weight: bold;
}
.aui-label.maui-label-gray {
  border: solid 1px #e7e7e7;
  color: #666;
  background: none;
}
.aui-list .aui-list-item-media {
  width: 6.5rem;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}
.aui-list-item-text.maui-price-text {
  font-size: 0.7rem;
  color: #ff7300;
  justify-content: flex-start;
}
.aui-list-item-text.maui-price-text span {
  font-size: 1rem;
}
.aui-list .aui-list-item i.aui-iconfont {
  font-size: 0.6rem;
}
.aui-media-list .aui-list-item-inner {
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}
.aui-list .aui-list-item {
  background: none;
  border-bottom: solid 1px #f0f0f0;
}
.aui-info.maui-time-text {
  font-size: 0.6rem;
  background: #fffbea;
}
.aui-list.maui-bidding-list .aui-list-item {
  padding-left: 0;
}
.aui-list.maui-bidding-list .aui-list-item .aui-info {
  padding: 0.5rem 0.75rem;
}
.aui-list.maui-bidding-list .aui-list-item-media {
  padding: 0.75rem;
}
.aui-list.maui-bidding-list .aui-list-item-inner {
  padding: 0.7rem 0.75rem 0.75rem 0;
}
.aui-list.maui-bidding-list .aui-info-item span {
  color: #ff7300;
}
.maui-field {
  font-size: 0.7rem;
  color: #757575;
}
.maui-field div {
  padding-right: 0.5rem;
  display: inline-block;
}

.maui-detailpage {
  margin-bottom: 2.2rem;
}
.aui-list.maui-detail-list .aui-list-item {
  padding-left: 0;
  border-bottom: solid 0.5rem #f6f6f6;
}
.aui-list.maui-detail-list .aui-list-item .aui-info {
  padding: 0.5rem 0.75rem;
}
.aui-list.maui-detail-list .aui-list-item-media {
  padding: 0.75rem;
}
.aui-list.maui-detail-list .aui-list-item-inner {
  padding: 0 0.75rem 0.75rem 0.75rem;
}
.aui-list.maui-detail-list .aui-info-item span {
  color: #ff7300;
}
.maui-detail-list .aui-list .aui-list-item {
  border-bottom: solid 10px #f0f0f0;
}
.maui_imgbox {
  margin: 0.75rem;
  display: flex;
  overflow: hidden;
  position: relative;
}
.maui_imgbox img {
  width: 11rem;
  padding-right: 0.5rem;
  max-width: none;
}
.maui-nobox {
  position: absolute;
  right: 0.35rem;
  bottom: 0.35rem;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  font-size: 0.6rem;
  padding: 0.15rem 0.35rem;
  border-radius: 0.3rem;
}
.maui-info-textbox h2 {
  padding: 0.75rem 0.75rem 0;
  font-size: 0.75rem;
  font-weight: bold;
}
.maui-info-textbox {
  border-bottom: solid 0.5rem #f6f6f6;
}
.maui-info-textbox .aui-list .aui-list-item-label,
.aui-list .aui-list-item-label-icon {
  width: 35%;
  color: #858484;
  font-size: 0.7rem;
}
.aui-input,
input[type="text"],
input[type="password"],
input[type="search"],
input[type="email"],
input[type="tel"],
input[type="url"],
input[type="date"],
input[type="datetime-local"],
input[type="time"],
input[type="number"],
select,
textarea {
  font-size: 0.7rem;
}
.maui-textbox {
  padding: 0.75rem;
  font-size: 0.7rem;
  color: #666;
  line-height: 2;
}
.aui-btn-block.maui-btn {
  background: #8cbfae;
  border-radius: 0;
  color: #fff;
  font-size: 0.8rem;
  height: 2.2rem;
  line-height: 2.2rem;
}

.aui-list .aui-list-item-media.maui-directories-media {
  width: 3.75rem;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}
.aui-list .aui-list-item-media.maui-directories-media img {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
}
.van-image-preview__image img {
  max-height: initial !important;
}
@media only screen and (max-width: 768px) {
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 100%;
  }
}
@media only screen and (max-width: 480px) {
  .aui-list .aui-list-item-label,
  .aui-list .aui-list-item-label-icon {
    width: 49%;
  }
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 100%;
  }
}
@media only screen and (max-width: 320px) {
  .aui-list .aui-list-item-label,
  .aui-list .aui-list-item-label-icon {
    width: 40%;
    font-size: 0.6rem;
  }
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 70%;
    font-size: 0.6rem;
  }
  .aui-input,
  input[type="text"],
  input[type="password"],
  input[type="search"],
  input[type="email"],
  input[type="tel"],
  input[type="url"],
  input[type="date"],
  input[type="datetime-local"],
  input[type="time"],
  input[type="number"],
  select,
  textarea {
    font-size: 0.6rem;
  }
}
.aui-content >>> .van-stepper__input {
  display: inline-block;
  width: 32px;
}
.mymarginleft {
  margin-left: 0.5rem;
}
.mymarginleft >>> .van-stepper__input {
  font-size: 0.8rem;
}
.my-img {
  max-width: 100%;
  margin: 0 auto;
}
</style>




// WEBPACK FOOTER //
// src/components/supplyform.vue